module.exports = __webpack_public_path__ + "static/media/instagram.cda6723d.svg";